import React from "react";
import { Box, Typography, Card, CardContent, Button, Chip } from "@mui/material";
import styles from "./IndexPage.module.css";
import { useNavigate } from "react-router-dom";  
import default_theme from "assets/themes/themes";
import wizard from "assets/images/wizardPage.jpg";
import solutions from "assets/images/solutionPage.jpg";
import workspaces from "assets/images/workspacesPage.jpg";

const Home = () => {
  const navigate = useNavigate(); 

  const sections = [
    {
      id: "solutions",
      title: "Solutions",
      description:
        "Discover rural development solutions from across Europe and beyond. Our platform connects you with proven strategies for sustainable rural transformation, covering everything from climate action and digital innovation to cultural preservation and community wellbeing.",
      image: solutions,
      buttonText: "Explore Solutions",
      color: default_theme.palette.other.chatGreen,
      route: "/solutions",
    },
    {
      id: "wizard",
      title: "Wizard",
      description:
        "Explore solutions across areas like sustainable mobility, energy transition, agrifood systems, nature-based tourism, cultural innovation, and local services. Each solution includes detailed information about challenges addressed, beneficiaries, required competencies, and implementation strategies.",
      image: wizard,
      buttonText: "Start Wizard",
      color: default_theme.palette.other.chatGreen,
      route: "/wizard",
    },
    {
      id: "workspaces",
      title: "Workspaces",
      description:
        "Create and manage local projects and initiatives. Set up tailored workspaces where your team can experiment with scenarios and track ideas aligned with rural development priorities.",
      image: workspaces,
      buttonText: "View Workspaces",
      color: default_theme.palette.other.chatGreen,
      route: "/workspaces",
    },
  ];

  const handleNavigation = (route) => {
    navigate(route);
  };

  const features = [
    "Climate Action Solutions",
    "Digital Innovation",
    "Cultural Preservation",
    "Community Wellbeing",
    "Sustainable Agriculture",
    "Rural Tourism"
  ];

  return (
    <Box className={styles.pageContainer}>
      {/* Hero Section */}
      <Box className={styles.heroSection}>
        <Box className={styles.heroContent}>
          <Typography variant="h2" className={styles.heroTitle}>
            RURACTIVE Decision Support Tool
          </Typography>
          <Typography variant="h6" className={styles.heroSubtitle}>
            Discover rural development solutions from across Europe and beyond. Our platform connects you 
            with proven strategies for sustainable rural transformation, covering everything from climate action and 
            digital innovation to cultural preservation and community wellbeing.
          </Typography>

          <Typography sx= {{p: '60px 0px 0px 0px'}} variant="h4" className={styles.heroSubtitle}>
            What You'll Find
          </Typography>
          <Typography variant="h6" className={styles.heroSubtitle}>
            Explore solutions across areas like, sustainable mobility, energy transition, 
            agrifood systems, nature-based tourism, cultural innovation, and local services. 
            Each solution includes detailed information about challenges addressed, beneficiaries, 
            required competencies, and implementation strategies.
          </Typography>
          <Box className={styles.featuresContainer}>
            {features.map((feature, index) => (
              <Chip
                key={index}
                label={feature}
                className={styles.featureChip}
                sx={{
                  animationDelay: `${index * 0.1}s`
                }}
              />
            ))}
          </Box>
        </Box>
      </Box>

      {/* Main Content Sections */}
      <Box className={styles.contentContainer}>
        {sections.map((section, index) => (
          <Card key={section.id} className={styles.sectionCard}>
            <Box className={styles.cardContent}>
              <Box className={styles.imageContainer}>
                <img
                  src={section.image}
                  alt={section.title}
                  className={styles.sectionImage}
                />
                <Box className={styles.imageOverlay} />
              </Box>
              <CardContent className={styles.textContent}>
                <Typography variant="h4" className={styles.sectionTitle}>
                  {section.title}
                </Typography>
                <Typography variant="body1" className={styles.sectionDescription}>
                  {section.description}
                </Typography>
                <Button
                  variant="contained"
                  className={styles.sectionButton}
                  onClick={() => handleNavigation(section.route)}
                  sx={{
                    backgroundColor: section.color,
                    '&:hover': {
                      backgroundColor: section.color,
                      filter: 'brightness(0.9)',
                      transform: 'translateY(-2px)',
                    }
                  }}
                >
                  {section.buttonText}
                </Button>
              </CardContent>
            </Box>
          </Card>
        ))}
      </Box>

      {/* Bottom CTA Section */}
      <Box className={styles.ctaSection}>
        <Typography variant="h4" className={styles.ctaTitle}>
          Ready to Transform Rural Communities?
        </Typography>
        <Typography variant="body1" className={styles.ctaDescription}>
          Join thousands of organizations already using RURACTIVE to drive sustainable change
        </Typography>
      </Box>
    </Box>
  );
};

export default Home;